"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useSetKeyboardNavigation", {
    enumerable: true,
    get: function() {
        return useSetKeyboardNavigation;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useKeyborg = require("./useKeyborg");
function useSetKeyboardNavigation() {
    const keyborg = (0, _useKeyborg.useKeyborg)();
    return _react.useCallback((isNavigatingWithKeyboard)=>{
        keyborg === null || keyborg === void 0 ? void 0 : keyborg.setVal(isNavigatingWithKeyboard);
    }, [
        keyborg
    ]);
}
